// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { dotSolidDotStroke16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-dot-solid-dot-stroke': IconDotSolidDotStroke;
    }
}

/**
 * The icon component for the 'dotSolidDotStroke' icon
 */
export class IconDotSolidDotStroke extends Icon {
    public constructor() {
        super(dotSolidDotStroke16X16);
    }
}

registerIcon('icon-dot-solid-dot-stroke', IconDotSolidDotStroke);
export const iconDotSolidDotStrokeTag = 'nimble-icon-dot-solid-dot-stroke';
